{
    "private": true,
    "name": "greenhouse-modeler",
    "version": "1.0.991",
    "engines": {
        "node": "^24",
        "pnpm": "^11"
    },
    "devEngines": {
        "runtime": {
            "name": "node",
            "version": "^24",
            "onFail": "error"
        }
    },
    "scripts": {
        "ng": "ng",
        "prepare": "cd .. && husky",
        "prestart": "pnpm localize",
        "start": "run-p -r start:server start:app",
        "start:app": "ng serve --open --watch --proxy-config proxy.conf.json",
        "start:app:proxy-bff": "ng serve --open --ssl --watch --proxy-config proxy-bffserver.conf.json",
        "start:server": "ts-node mock-server/server",
        "start:bffserver": "cross-env dotnet run --project ../Server/BffServer/Priva.Greenhouse.Modeler.BffServer.csproj --launch-profile https",
        "start:wait": "wait-on http://localhost:4200",
        "start:wait-mock-server": "wait-on http://localhost:9005",
        "build": "pnpm localize && ng build",
        "build:tst": "pnpm localize && ng build --configuration test",
        "build:acc": "pnpm localize && ng build --configuration acceptance",
        "build:prod": "pnpm localize && ng build --configuration production",
        "build:source-maps": "pnpm localize && ng build --configuration=production --source-map",
        "test": "jest --coverage --maxWorkers=50% --config=jest.config.js ./src",
        "test:watch": "jest --coverage --maxWorkers=25% --watch",
        "lint": "pnpm lint:check",
        "lint:check": "run-p lint:check:*",
        "lint:check:scripts": "set NODE_OPTIONS=--max-old-space-size=8192 & eslint . --cache",
        "lint:check:styles": "stylelint **/*.{css,scss} --cache",
        "lint:check:format": "prettier --check . --ignore-unknown --log-level warn",
        "lint:fix": "run-p lint:fix:*",
        "lint:fix:scripts": "set NODE_OPTIONS=--max-old-space-size=8192 & eslint . --fix --cache",
        "lint:fix:styles": "stylelint --fix **/*.{css,scss} --cache",
        "lint:fix:format": "prettier --write . --ignore-unknown --log-level warn",
        "analyze-bundle-size": "pnpm build:source-maps && source-map-explorer dist/*.js",
        "localize": "localization-cli --sourcePaths localization/source --destinationPath src/assets/translations",
        "localize:debug": "localization-cli --verbose --sourcePaths localization/source --destinationPath src/assets/translations"
    },
    "prettier": "@priva/linter/prettier-config",
    "dependencies": {
        "@angular-architects/native-federation": "^21.2.6",
        "@angular-architects/ngrx-toolkit": "^21.0.1",
        "@angular/animations": "^21.2.23",
        "@angular/cdk": "^21.2.14",
        "@angular/common": "^21.2.23",
        "@angular/compiler": "^21.2.23",
        "@angular/core": "^21.2.23",
        "@angular/forms": "^21.2.23",
        "@angular/platform-browser": "^21.2.23",
        "@angular/platform-browser-dynamic": "^21.2.23",
        "@angular/router": "^21.2.23",
        "@angular/service-worker": "^21.2.23",
        "@ng-select/ng-select": "^21.8.2",
        "@ngrx/effects": "21.1.1",
        "@ngrx/operators": "21.1.1",
        "@ngrx/router-store": "21.1.1",
        "@ngrx/signals": "^21.1.1",
        "@ngrx/store": "21.1.1",
        "@ngrx/store-devtools": "21.1.1",
        "@ngx-translate/core": "^17.0.0",
        "@popperjs/core": "^2.11.8",
        "@priva/analytics": "^16.3.1",
        "@priva/applayout": "^1.6.0",
        "@priva/apps": "^3.2.1",
        "@priva/appshell": "^31.5.0",
        "@priva/auth": "^18.1.1",
        "@priva/components": "^58.12.2",
        "@priva/dataviz": "^1.6.0",
        "@priva/error-pages": "^19.11.0",
        "@priva/localization": "^21.8.0",
        "@priva/microfrontends": "^4.12.0",
        "@priva/notifications": "^4.11.0",
        "@priva/preferences": "^3.5.1",
        "@priva/preloader": "^1.5.0",
        "@priva/styles": "^42.2.3",
        "@priva/utilities": "^16.15.1",
        "@priva/variables": "^1.2.0",
        "@privaone/masterdata": "^1.12.0",
        "@segment/analytics-next": "^1.84.3",
        "date-fns": "^2.30.0",
        "dayjs": "1.11.21",
        "ng2-date-picker": "^21.0.1",
        "ngx-segment-analytics": "^19.0.1",
        "ngx-window-token": "^7.0.0",
        "object-hash": "^3.0.0",
        "rxjs": "~7.8.2",
        "tslib": "^2.8.1",
        "zone.js": "~0.16.3"
    },
    "devDependencies": {
        "@angular-builders/jest": "^21.0.4",
        "@angular-devkit/build-angular": "^21.2.24",
        "@angular-devkit/core": "^21.2.24",
        "@angular-devkit/schematics": "^21.2.24",
        "@angular-eslint/eslint-plugin": "^21.4.0",
        "@angular-eslint/eslint-plugin-template": "^21.4.0",
        "@angular-eslint/template-parser": "^21.4.0",
        "@angular/build": "^21.2.24",
        "@angular/cli": "~21.2.24",
        "@angular/compiler-cli": "^21.2.23",
        "@angular/language-service": "^21.2.23",
        "@eslint/eslintrc": "^3.3.7",
        "@eslint/js": "^8.57.1",
        "@playwright/test": "^1.63.0",
        "@priva/linter": "^13.5.1",
        "@priva/localization-cli": "^5.6.1",
        "@priva/mock-server": "^3.1.1",
        "@priva/preferences": "^3",
        "@types/express": "5.0.6",
        "@types/express-serve-static-core": "5.1.3",
        "@types/jest": "^30.0.0",
        "@types/node": "^26.6.1",
        "@types/object-hash": "^3.0.6",
        "@typescript-eslint/eslint-plugin": "^8.70.0",
        "clean": "^4.0.2",
        "cross-env": "^10.1.0",
        "eslint": "^8.57.1",
        "eslint-plugin-playwright": "^2.12.0",
        "eslint-plugin-prettier": "^5.5.6",
        "eslint-plugin-unused-imports": "^4.4.1",
        "glob": "^13.0.6",
        "husky": "^9.1.7",
        "jest": "^30.5.1",
        "jest-environment-jsdom": "^30.5.1",
        "jest-preset-angular": "^17.0.0",
        "lint-staged": "^17.5.1",
        "ng-mocks": "^14.18.0",
        "npm-run-all": "^4.1.5",
        "postcss": "^8.5.28",
        "prettier": "^3.9.7",
        "routing-controllers": "^0.11.3",
        "sass": "~1.102.0",
        "source-map-explorer": "^2.5.3",
        "stylelint": "^17.15.0",
        "stylelint-config-standard": "^40.0.0",
        "stylelint-declaration-strict-value": "^1.12.1",
        "stylelint-order": "^8.1.1",
        "ts-jest": "^29.4.12",
        "ts-node": "^10.9.2",
        "typedi": "^0.10.0",
        "typescript": "~5.9.3",
        "wait-on": "^9.1.0",
        "ws": "^8.21.3"
    },
    "packageManager": "pnpm@11.5.1"
}
